import { DateTime } from 'luxon';

export function DateMes(date: any){
    const dataObjeto = new Date(date);
    const nomeMes = new Intl.DateTimeFormat('pt-BR', { month: 'long' }).format(dataObjeto).replace(/^\w/, (c) => c.toUpperCase());
    
    const resultado = `${nomeMes}`;
    return resultado
}

export function DateAno(date: any){
    const dataObjeto = new Date(date);
    const ano = dataObjeto.getFullYear();

    const resultado = `${ano}`;
    return resultado
}

export function DateCommon(date: any){
    const dataObjeto = new Date(date);
    const dia = dataObjeto.getDate();
    const mes = dataObjeto.getMonth() + 1;
    

    const dataFormat = `${dia}/${mes}`;
    return dataFormat
}

export function formatDateInverter(inputDate: string) {
  if (/^\d{4}-\d{2}-\d{2}$/.test(inputDate)) {
    const [year, month, day] = inputDate.split("-");
    return `${day}-${month}-${year}`;
  }

  if (/^\d{4}-\d{2}$/.test(inputDate)) {
    const [year, month] = inputDate.split("-");
    return `${month}-${year}`;
  }

  return inputDate;
}

export function getCurrentMonthFormatted(){
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  return `${month}/${year}`;
};


export function DateComplete(date: any){
    const dataObjeto = new Date(date);
    const dia = padZero(dataObjeto.getDate());
    const mes = padZero(dataObjeto.getMonth() + 1);
    const ano = padZero(dataObjeto.getFullYear());

    const dataFormat = `${dia}-${mes}-${ano}`;
    return dataFormat
}

export function DateCompleteMount(date: any){
  const dataObjeto = new Date(date);
  const mes = padZero(dataObjeto.getMonth() + 1);
  const ano = padZero(dataObjeto.getFullYear());

  const dataFormat = `${mes}/${ano}`;
  return dataFormat
}

export function DateCompleteV2(date: any){
  const dataObjeto = new Date(date);
  const dia = padZero(dataObjeto.getDate());
  const mes = padZero(dataObjeto.getMonth() + 1);
  const ano = padZero(dataObjeto.getFullYear());

  const dataFormat = `${ano}-${mes}-${dia}`;
  return dataFormat
}

export function DateCompleteBarra(date: any){
    const dataObjeto = new Date(date);
    const dia = padZero(dataObjeto.getDate());
    const mes = padZero(dataObjeto.getMonth() + 1);
    const ano = padZero(dataObjeto.getFullYear());

    const dataFormat = `${dia}/${mes}/${ano}`;
    return dataFormat
}

export function formatDateTimeBarra(date: any){
    if (!date) return "";
    const dataObjeto = new Date(date);
    if (isNaN(dataObjeto.getTime())) return "";

    const dia = padZero(dataObjeto.getDate());
    const mes = padZero(dataObjeto.getMonth() + 1);
    const ano = padZero(dataObjeto.getFullYear());
    const horas = padZero(dataObjeto.getHours());
    const minutos = padZero(dataObjeto.getMinutes());

    return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
}

export function DateCompleteMesAno(date: any){
  const dataObjeto = new Date(date);
  //const dia = padZero(dataObjeto.getDate());
  const mes = padZero(dataObjeto.getMonth() + 1);
  const ano = padZero(dataObjeto.getFullYear());

  const dataFormat = `${ano}-${mes}`;
  return dataFormat
}

export function DateCompleteAno(date: any){
  const dataObjeto = new Date(date);
  const ano = padZero(dataObjeto.getFullYear());

  const dataFormat = `${ano}`;
  return dataFormat
}

function padZero(numero: number) {
    return numero < 10 ? `0${numero}` : numero;
}

export function formatarDataParaString(data: Date) {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Mês é base 0, então somamos 1
    const dia = String(data.getDate()).padStart(2, '0');
    const horas = String(data.getHours()).padStart(2, '0');
    const minutos = String(data.getMinutes()).padStart(2, '0');
  
    return `${ano}-${mes}-${dia}T${horas}:${minutos}`;
}

export function formatarData(dataISO) {
    const diasSemana = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
    const meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
    
    const data = new Date(dataISO);
    
    const diaSemana = diasSemana[data.getDay()];
    const dia = data.getDate();
    const mes = meses[data.getMonth()];
    const horas = data.getHours();
    const minutos = data.getMinutes();
    
    const dataFormatada = diaSemana + ", " + dia + " de " + mes + ", às " + horas + ":" + minutos + " horas";
    
    return dataFormatada;
}

export function formatarDataOS(dataISO) {
  const diasSemana = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
  const meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  
  const data = new Date(dataISO);
  // Subtrai 3 horas devido ao fuso horário (UTC-3)
  data.setHours(data.getHours() - 3);
  
  const diaSemana = diasSemana[data.getDay()];
  const dia = data.getDate();
  const mes = meses[data.getMonth()];
  const horas = data.getHours();
  const minutos = data.getMinutes();
  
  const dataFormatada = diaSemana + ", " + dia + " de " + mes + ", às " + horas + ":" + minutos + " horas";
  
  return dataFormatada;
}

export function formatarDataV2(dataISO) {
  //const diasSemana = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
  const meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  
  const data = new Date(dataISO);
  
  //const diaSemana = diasSemana[data.getDay()];
  const dia = data.getDate();
  const mes = meses[data.getMonth()];
  const horas = data.getHours();
  const minutos = data.getMinutes();
  
  const dataFormatada = dia + " de " + mes + ", às " + horas + ":" + minutos + " horas";
  
  return dataFormatada;
}

export function formatarDataV3(dataISO) {
  //const diasSemana = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
  const meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  
  const data = new Date(dataISO);
  
  //const diaSemana = diasSemana[data.getDay()];
  const dia = data.getDate();
  const mes = meses[data.getMonth()];
  //const horas = data.getHours();
  //const minutos = data.getMinutes();
  const ano = data.getFullYear();
  
  const dataFormatada = dia + " de " + mes + " de " + ano;
  
  return dataFormatada;
}

export function formatDateV4(dateString: string) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year}, às ${hours}:${minutes}`;
}

export function formatDateV5OS(dateString: string) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  
  // Subtrai 3 horas devido ao fuso horário (UTC-3)
  date.setHours(date.getHours() - 3);
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year}, às ${hours}:${minutes}`;
}


export function extrairMesDia(dataString: any) {
    const partes = dataString.split("-");
    const mes = partes[1];
    const dia = partes[2];
    return `${dia}-${mes}`
    //return { mes: parseInt(mes, 10), dia: parseInt(dia, 10) };
  }

  export function extrairMesDiaBarra(dataString: any) {
    const partes = dataString.split("-");
    const mes = partes[1];
    const dia = partes[2];
    return `${dia} / ${mes}`
    //return { mes: parseInt(mes, 10), dia: parseInt(dia, 10) };
  }

export function getShortMonthName(dateString: string) {
    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const date = new Date(dateString);
    const monthIndex = date.getMonth();
    return months[monthIndex];
}

export function formatDate(date: Date) {
    const dataObjeto = new Date(date);
    const monthNames = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
    const month = dataObjeto.getMonth();
    const year = dataObjeto.getFullYear();
    return `${monthNames[month]}/${year}`;
}

export const formatDateToYYYYMMDD = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  };

export function getShortMonthNameString(dateString: string) {
    const shortMonthNames = {
        '01': 'jan',
        '02': 'fev',
        '03': 'mar',
        '04': 'abr',
        '05': 'may', 
        '06': 'jun',
        '07': 'jul',
        '08': 'ago',
        '09': 'sep', 
        '10': 'oct', 
        '11': 'nov',
        '12': 'dez'
    };

    const month = dateString.split('-')[1];

    return shortMonthNames[month];
}

export function getDayOfWeek(dt) {
  const daysOfWeek = [
    "Domingo",
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado"
  ];

  const date = new Date(dt * 1000);

  const today = new Date();

  if (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  ) {
    return "Hoje";
  }

  // Retorna o dia da semana correspondente
  return daysOfWeek[date.getDay()];
}


const isDateString = (dateString) => {
    return /^\d{2}\/\d{2}\/\d{4}$/.test(dateString);
};
  
export const parseDate = (dateString: string) => {
    if (isDateString(dateString)) {
        const [day, month, year] = dateString.split('/');
        return new Date(`${year}-${month}-${day}`);
    }
    return new Date(dateString);
};
  
export const nameMes = (dateString: string) => {
    const mounthYear = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ];

      const data = new Date(dateString);
      //const year = data.getFullYear();
      const month = data.getMonth() + 1;
      const nameMonth = mounthYear[month - 1];

      return nameMonth
}

export function formatDateToNumbers(dateString: string) {
  const date = new Date(dateString);
  const pad = (n) => n.toString().padStart(2, '0');

  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date.getUTCDate());
  const hours = pad(date.getUTCHours());
  const minutes = pad(date.getUTCMinutes());
  const seconds = pad(date.getUTCSeconds());
  const milliseconds = Math.floor(date.getUTCMilliseconds() / 10);

  return `${year}${month}${day}${hours}${minutes}${seconds}${pad(milliseconds)}`;
}

// export function tempoPassado(dataEspecifica: string): string {
//   const dataAtual = new Date();

//   const dataLocal = new Date(dataEspecifica.replace(/Z$/, ''));

//   let diferenca = dataAtual.getTime() - dataLocal.getTime();

//   const segundos = Math.floor(diferenca / 1000);
//   const minutos = Math.floor(segundos / 60);
//   const horas = Math.floor(minutos / 60);
//   const dias = Math.floor(horas / 24);
//   const meses = Math.floor(dias / 30);
//   const anos = Math.floor(meses / 12);

//   const valores = {
//     anos,
//     meses: meses % 12,
//     dias: dias % 30,
//     horas: horas % 24,
//     minutos: minutos % 60,
//     segundos: segundos % 60,
//   };

//   const formatarTempo = (valor: number, unidade: string) =>
//     valor > 0 ? `${valor}${unidade}` : '';

//   let partes: string[] = [];

//   if (valores.anos) {
//     partes.push(formatarTempo(valores.anos, 'a'));
//     if (valores.meses) partes.push(formatarTempo(valores.meses, 'm'));
//   } else if (valores.meses) {
//     partes.push(formatarTempo(valores.meses, 'm'));
//     if (valores.dias) partes.push(formatarTempo(valores.dias, 'd'));
//   } else if (valores.dias) {
//     partes.push(formatarTempo(valores.dias, 'd'));
//     if (valores.horas) partes.push(formatarTempo(valores.horas, 'h'));
//   } else if (valores.horas) {
//     partes.push(formatarTempo(valores.horas, 'h'));
//     if (valores.minutos) partes.push(formatarTempo(valores.minutos, 'min'));
//   } else if (valores.minutos) {
//     partes.push(formatarTempo(valores.minutos, 'min'));
//   } else if (valores.segundos) {
//     partes.push(formatarTempo(valores.segundos, 's'));
//   }

//   const dateFinal =
//     partes.length > 1
//       ? partes.slice(0, -1).join(', ') + ' e ' + partes.slice(-1)
//       : partes[0] || 'agora';

//   return dateFinal;
// }


// export function tempoPassado(dataEspecifica: string): string {
//   const dataAtual = new Date();
//   const offsetMs = dataAtual.getTimezoneOffset() * 60 * 1000;
//   const dataAtualLocal = new Date(dataAtual.getTime() - offsetMs);

//   const dataLocal = new Date(dataEspecifica.replace(/Z$/, ''));
//   const dataLocalAjustada = new Date(dataLocal.getTime() - offsetMs);


//   let diferenca = dataAtualLocal.getTime() - dataLocalAjustada.getTime();
//   const isFuture = diferenca < 0;
//   diferenca = Math.abs(diferenca);

//   const segundos = Math.floor(diferenca / 1000);
//   const minutos = Math.floor(segundos / 60);
//   const horas = Math.floor(minutos / 60);
//   const dias = Math.floor(horas / 24);
//   const meses = Math.floor(dias / 30);
//   const anos = Math.floor(meses / 12);

//   const valores = {
//     anos,
//     meses: meses % 12,
//     dias: dias % 30,
//     horas: horas % 24,
//     minutos: minutos % 60,
//     segundos: segundos % 60,
//   };

//   const formatarTempo = (valor: number, unidade: string) =>
//     valor > 0 ? `${valor}${unidade}` : '';

//   let partes: string[] = [];

//   if (valores.anos) {
//     partes.push(formatarTempo(valores.anos, 'a'));
//     if (valores.meses) partes.push(formatarTempo(valores.meses, 'm'));
//   } else if (valores.meses) {
//     partes.push(formatarTempo(valores.meses, 'm'));
//     if (valores.dias) partes.push(formatarTempo(valores.dias, 'd'));
//   } else if (valores.dias) {
//     partes.push(formatarTempo(valores.dias, 'd'));
//     if (valores.horas) partes.push(formatarTempo(valores.horas, 'h'));
//   } else if (valores.horas) {
//     partes.push(formatarTempo(valores.horas, 'h'));
//     if (valores.minutos) partes.push(formatarTempo(valores.minutos, 'min'));
//   } else if (valores.minutos) {
//     partes.push(formatarTempo(valores.minutos, 'min'));
//   } else if (valores.segundos) {
//     partes.push(formatarTempo(valores.segundos, 's'));
//   }

//   let dateFinal: string;
//   if (partes.length > 1) {
//     dateFinal = partes.slice(0, -1).join(', ') + ' e ' + partes.slice(-1);
//   } else if (partes.length === 1) {
//     dateFinal = partes[0];
//   } else {
//     dateFinal = isFuture ? 'daqui a instantes' : 'agora';
//   }

//   return isFuture ? `daqui a ${dateFinal}` : dateFinal;
// }

// export function tempoPassado(dataEspecifica: string): string {
//   const dataAtual = new Date();

//   const dataSemZ = dataEspecifica.replace(/Z$/, '');


//   const [dataParte, horaParte] = dataSemZ.split('T');
//   const [ano, mes, dia] = dataParte.split('-').map(Number);
//   const [hora, minuto, segundo] = horaParte.split(':').map(Number);

//   const dataNotificacao = new Date(ano, mes - 1, dia, hora, minuto, segundo);

//   let diferenca = dataAtual.getTime() - dataNotificacao.getTime();
//   const isFuture = diferenca < 0;
//   diferenca = Math.abs(diferenca);

//   const segundos = Math.floor(diferenca / 1000);
//   const minutos = Math.floor(segundos / 60);
//   const horas = Math.floor(minutos / 60);
//   const dias = Math.floor(horas / 24);
//   const meses = Math.floor(dias / 30);
//   const anos = Math.floor(meses / 12);

//   const valores = {
//     anos,
//     meses: meses % 12,
//     dias: dias % 30,
//     horas: horas % 24,
//     minutos: minutos % 60,
//     segundos: segundos % 60,
//   };

//   const formatarTempo = (valor: number, unidade: string) =>
//     valor > 0 ? `${valor}${unidade}` : '';

//   let partes: string[] = [];

//   if (valores.anos) {
//     partes.push(formatarTempo(valores.anos, 'a'));
//     if (valores.meses) partes.push(formatarTempo(valores.meses, 'm'));
//   } else if (valores.meses) {
//     partes.push(formatarTempo(valores.meses, 'm'));
//     if (valores.dias) partes.push(formatarTempo(valores.dias, 'd'));
//   } else if (valores.dias) {
//     partes.push(formatarTempo(valores.dias, 'd'));
//     if (valores.horas) partes.push(formatarTempo(valores.horas, 'h'));
//   } else if (valores.horas) {
//     partes.push(formatarTempo(valores.horas, 'h'));
//     if (valores.minutos) partes.push(formatarTempo(valores.minutos, 'min'));
//   } else if (valores.minutos) {
//     partes.push(formatarTempo(valores.minutos, 'min'));
//   } else if (valores.segundos) {
//     partes.push(formatarTempo(valores.segundos, 's'));
//   }

//   let dateFinal: string;
//   if (partes.length > 1) {
//     dateFinal = partes.slice(0, -1).join(', ') + ' e ' + partes.slice(-1);
//   } else if (partes.length === 1) {
//     dateFinal = partes[0];
//   } else {
//     dateFinal = isFuture ? 'daqui a instantes' : 'agora';
//   }

//   return isFuture ? `daqui a ${dateFinal}` : dateFinal;
// }

export function tempoPassado(dataEspecifica: string): string {
  const dataReferencia = DateTime.fromISO(dataEspecifica.includes('T') ? dataEspecifica : dataEspecifica.replace(' ', 'T'), {
    zone: 'America/Fortaleza',
  }).minus({ hours: 3 }); // Subtrai 3 horas devido ao fuso horário (UTC-3)

  const agora = DateTime.now().setZone('America/Fortaleza');

  const isFuture = dataReferencia > agora;
  const diff = isFuture
    ? dataReferencia.diff(agora, ['years', 'months', 'days', 'hours', 'minutes', 'seconds']).toObject()
    : agora.diff(dataReferencia, ['years', 'months', 'days', 'hours', 'minutes', 'seconds']).toObject();

  const valores = {
    anos: Math.floor(diff.years || 0),
    meses: Math.floor(diff.months || 0),
    dias: Math.floor(diff.days || 0),
    horas: Math.floor(diff.hours || 0),
    minutos: Math.floor(diff.minutes || 0),
    segundos: Math.floor(diff.seconds || 0),
  };

  const formatarTempo = (valor: number, unidade: string) =>
    valor > 0 ? `${valor}${unidade}` : '';

  let partes: string[] = [];

  if (valores.anos) {
    partes.push(formatarTempo(valores.anos, 'a'));
    if (valores.meses) partes.push(formatarTempo(valores.meses, 'm'));
  } else if (valores.meses) {
    partes.push(formatarTempo(valores.meses, 'm'));
    if (valores.dias) partes.push(formatarTempo(valores.dias, 'd'));
  } else if (valores.dias) {
    partes.push(formatarTempo(valores.dias, 'd'));
    if (valores.horas) partes.push(formatarTempo(valores.horas, 'h'));
  } else if (valores.horas) {
    partes.push(formatarTempo(valores.horas, 'h'));
    if (valores.minutos) partes.push(formatarTempo(valores.minutos, 'min'));
  } else if (valores.minutos) {
    partes.push(formatarTempo(valores.minutos, 'min'));
  } else if (valores.segundos) {
    partes.push(formatarTempo(valores.segundos, 's'));
  }

  let dateFinal: string;
  if (partes.length > 1) {
    dateFinal = partes.slice(0, -1).join(', ') + ' e ' + partes.slice(-1);
  } else if (partes.length === 1) {
    dateFinal = partes[0];
  } else {
    dateFinal = isFuture ? 'daqui a instantes' : 'agora';
  }

  return isFuture ? `daqui a ${dateFinal}` : dateFinal;
}


  export function formatDateToInput(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }
